import React from 'react';
import Image from 'next/image';
import {
  optimizeImageUrl,
  optimizeVideoUrl
} from '../../utils/videoLinkOptimize';
import Link from 'next/link';
import { isVideo } from '../../utils/isVideo';
interface MobileGalleryProps {
  media: { url: string; alt: string; name: string }[];
  productName?: string;
  onClose: () => void;
  onImageClick: (index: number) => void;
}

const MobileGallery = ({
  media,
  productName,
  onClose,
  onImageClick
}: MobileGalleryProps) => {
  const renderGalleryItem = (
    mediaItem: { url: string; alt: string; name: string },
    index: number,
    isFullWidth: boolean
  ) => {
    return (
      <div
        key={index}
        className={`cursor-pointer ${isFullWidth ? 'col-span-2' : ''}`}
        onClick={() => onImageClick(index)}
      >
        {!isVideo(mediaItem.url) ? (
          <Image
            src={optimizeImageUrl(mediaItem.url)}
            alt={mediaItem.alt || `${productName} image ${index + 1}`}
            width={isFullWidth ? 1000 : 400}
            height={isFullWidth ? 1000 : 400}
            className={`w-full object-cover h-[261px] `}
            placeholder="blur"
            blurDataURL="/placeholder.webp"
          />
        ) : (
          <div className={`relative w-full overflow-hidden h-[261px]`}>
            <video
              src={optimizeVideoUrl(mediaItem.url)}
              className="w-full h-full object-cover"
              muted
              playsInline
            />
            {/* Video play icon overlay */}
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
              <div className="w-12 h-12 bg-white bg-opacity-90 rounded-full flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-gray-800 ml-1"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-white z-[10000] overflow-y-auto">
      {/* Header */}
      <div
        className="flex items-center text-primary p-6 gap-2 font-[800] text-[16px] leading-[24px]"
        onClick={onClose}
      >
        <Image
          src={'/black-left-arrow.svg'}
          alt="left arrow"
          width={8}
          height={10}
        />
        {productName}
      </div>

      {/* Gallery Grid */}
      <div className="pb-16">
        <div className="grid grid-cols-2 gap-[1px]">
          {media?.map((mediaItem, index) => {
            const isFullWidth = index % 3 === 0;
            return renderGalleryItem(mediaItem, index, isFullWidth);
          })}
        </div>
      </div>
    </div>
  );
};

export default MobileGallery;
